import PrintableDocument from './PrintableDocument';

interface SoinItem {
  date: string;
  description: string;
}

interface PrintableFicheSoinProps {
  patientName: string;
  practitionerName: string;
  practitionerTitle?: string;
  date: string;
  soins: SoinItem[];
  verificationUrl?: string;
  onReady?: () => void;
}

export default function PrintableFicheSoin({
  patientName,
  practitionerName,
  practitionerTitle,
  date,
  soins,
  verificationUrl,
  onReady,
}: PrintableFicheSoinProps) {
  const soinsValides = soins.filter((s) => s.description.trim());

  return (
    <PrintableDocument
      documentTitle="Fiche de Soins"
      patientName={patientName}
      practitionerName={practitionerName}
      practitionerTitle={practitionerTitle}
      date={date}
      verificationUrl={verificationUrl}
      letterhead
      onReady={onReady}
    >
      {soinsValides.length === 0 ? (
        <div className="print-text" style={{ marginBottom: '4mm', color: '#999', fontStyle: 'italic' }}>
          Aucun soin renseigné.
        </div>
      ) : (
        <>
          <div className="print-section-title">
            <i className="ri-nurse-fill" style={{ marginRight: '6px', fontSize: '14px' }}></i>
            Soins à administrer
          </div>
          <table className="print-table" style={{ marginBottom: '4mm' }}>
            <thead>
              <tr>
                <th style={{ width: '110px' }}>Date</th>
                <th>Soin / Acte</th>
              </tr>
            </thead>
            <tbody>
              {soinsValides.map((s, i) => (
                <tr key={i}>
                  <td>{s.date ? new Date(s.date).toLocaleDateString('fr-FR') : '—'}</td>
                  <td>{s.description}</td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Instructions générales */}
          <div className="print-section-title" style={{ marginTop: '6mm' }}>
            <i className="ri-information-fill" style={{ marginRight: '6px', fontSize: '14px' }}></i>
            Instructions
          </div>
          <div className="print-text">
            Les soins doivent être administrés conformément aux dates indiquées.
            En cas de doute, contacter le prescripteur.
          </div>
        </>
      )}

      {/* Signature */}
      <div style={{ marginTop: '10mm', textAlign: 'right' }}>
        <div style={{ fontSize: '10pt', color: '#666' }}>{practitionerName}</div>
        {practitionerTitle && <div style={{ fontSize: '9pt', color: '#999' }}>{practitionerTitle}</div>}
      </div>
    </PrintableDocument>
  );
}